import Credit from './Credit';

export default Credit
export { Credit as Base }